<script lang="ts" setup>
import type { TripRouteStop } from "@/types/trip";
import RouteStopIcon from "@/components/icons/RouteStopIcon.vue";
import { OrderStopType } from "@/constants/order";

defineProps<{
  stop: TripRouteStop;
}>();

const emits = defineEmits<{
  (e: "chose", type: OrderStopType): void;
}>();
</script>

<template>
  <div class="d-flex flex-column row-gap-2 h-100">
    <div class="stop-type__container">
      <div class="d-flex align-center">
        <route-stop-icon
          :is-deleted="stop.isDeleted"
          :is-reload="stop.isReload"
          :type="OrderStopType.delivery"
          class="mr-2"
          size="20"
        ></route-stop-icon>

        <span class="font-weight-600 mr-3 font-size-12 text-grey-darken-1" data-qa="stop-type">
          Delivery #{{ stop.number }}
        </span>
      </div>

      <div class="stop-type__button">
        <v-btn class="text-primary" variant="flat" @click="emits('chose', OrderStopType.delivery)">
          <v-icon class="mr-1" icon="mdi-plus"></v-icon>
          Delivery
        </v-btn>
      </div>
    </div>

    <div class="stop-type__container">
      <div class="d-flex align-center">
        <route-stop-icon
          :is-deleted="stop.isDeleted"
          :is-reload="stop.isReload"
          :type="OrderStopType.pickup"
          class="mr-2"
          size="20"
        ></route-stop-icon>

        <span class="font-weight-600 mr-3 font-size-12 text-grey-darken-1" data-qa="stop-type">
          Pick up #{{ stop.number }}
        </span>
      </div>

      <div class="stop-type__button">
        <v-btn class="text-primary" variant="flat" @click="emits('chose', OrderStopType.pickup)">
          <v-icon class="mr-1" icon="mdi-plus"></v-icon>
          Pick up
        </v-btn>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/color";

.stop-type {
  &__container {
    border: 2px dashed #ff9800;
    border-radius: 8px;
    flex: 1;
    padding: 16px;
  }

  &__button {
    display: flex;
    justify-content: center;
    align-items: end;
    height: calc(100% - 20px);
  }
}
</style>
